module.exports = __webpack_public_path__ + "img/bgsignup.e534ff12.png";